import React from 'react';
import { Users } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Team = () => {
  const leadershipTeam = [
    {
      id: 1,
      name: 'Monita Borgohain IAS',
      role: 'Festival Director',
      image: '/images/team/monita-borgohain.jpg'
    }
  ];

  const advisoryBoard = [
    {
      id: 1,
      name: 'Manju Borah',
      role: 'Advisory Board Member',
      image: '/images/team/manju-borah.jpg'
    },
    {
      id: 2,
      name: 'Srinivasa Santhanam',
      role: 'Advisory Board Member',
      image: '/images/team/srinivasa-santhanam.webp'
    },
    {
      id: 3,
      name: 'Utpal Borpujari',
      role: 'Advisory Board Member',
      image: '/images/team/utpal-borpujari.png'
    },
    {
      id: 4,
      name: 'Anupama Bose',
      role: 'Advisory Board Member',
      image: '/images/team/anupama.jpg'
    }
  ];

  const coreTeam = [
    {
      id: 1,
      name: 'Himjyoti Talukdar',
      role: 'Creative & Communication Director',
      image: '/images/team/himjyoti-talukdar.jpg'
    },
    {
      id: 2,
      name: 'Kishore Kumar Sarma',
      role: 'Programming Director',
      image: '/images/team/kishore-kumar-sarma.jpg'
    },
    {
      id: 3,
      name: 'Dr Muktismaan Hazarika',
      role: 'Executive & Communication Director',
      image: '/images/team/muktismaan-hazarika.jpg'
    }
  ];

  const executiveMembers = [
    'Amardeep Gogoi',
    'Bhargav Das',
    'Dr Bimal Sarma',
    'Ditimoni Gogoi',
    'Hemanta Kumar Das',
    'Jayanta Deka',
    'Joydeep Das',
    'Kangkan Deka',
    'Mridusmita Sadhanidar',
    'Rupam Kumar Bora',
    'Tanmoy Nath',
    'Hiranya Kalita',
    'Jyoti Prakash Nath',
    'Dipankar Saikia',
    'Prakash Upadhyay',
    'Sudipta Sagar Kalita',
    'Abhijit Matak',
    'Trideep Lahkar',
    'Abdul Gani',
    'Suman Dev Choudhury',
    'Hiten Thakuria',
    'Hiranya Jyoti Das'
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-7xl md:text-9xl font-bold mb-8 leading-tight">
              OUR <span className="text-red-500">TEAM</span>
            </h1>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
            <p className="text-2xl md:text-3xl font-bold uppercase tracking-wider mb-4">
              DEDICATION. EXPERTISE. PASSION.
            </p>
            <p className="text-lg text-gray-400 max-w-3xl mx-auto">
              The Guwahati Asian Film Festival (GAFF) team comprises vibrant, experienced, and dedicated members who are prominent figures in their respective fields.
            </p>
          </div>
        </div>
      </section>

      {/* Festival Director */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              FESTIVAL DIRECTOR
            </h2>
            
            <div className="flex justify-center">
              {leadershipTeam.map((member) => (
                <div key={member.id} className="group text-center max-w-sm">
                  <div className="relative w-64 h-64 mx-auto mb-6 rounded-2xl overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{member.name}</h3>
                  <p className="text-red-500 uppercase tracking-wider text-sm">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Advisory Board */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              ADVISORY BOARD
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
              {advisoryBoard.map((member, index) => (
                <div
                  key={member.id}
                  className="group text-center"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                >
                  <div className="relative w-64 h-64 mx-auto mb-6 rounded-2xl overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{member.name}</h3>
                  <p className="text-gray-400 uppercase tracking-wider text-sm">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Core Team */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              CORE TEAM
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {coreTeam.map((member, index) => (
                <div
                  key={member.id}
                  className="group text-center"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                >
                  <div className="relative w-64 h-64 mx-auto mb-6 rounded-2xl overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{member.name}</h3>
                  <p className="text-gray-400 uppercase tracking-wider text-sm">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Executive Members */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">
              EXECUTIVE MEMBERS
            </h2>
            
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {executiveMembers.map((name, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-4 bg-white/5 rounded-lg hover:bg-red-500/10 transition-all duration-300"
                    style={{
                      animation: `fadeInUp 0.6s ease-out ${index * 0.05}s both`
                    }}
                  >
                    <div className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0"></div>
                    <p className="text-base font-semibold">{name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


      <Footer />

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Team;
